import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 8.3541C3 7.21779 3.64201 6.179 4.65836 5.67082L10.6584 2.67082C11.5029 2.24853 12.4971 2.24853 13.3416 2.67082L19.3416 5.67082C20.358 6.179 21 7.21779 21 8.3541V15.6459C21 16.7822 20.358 17.821 19.3416 18.3292L13.3416 21.3292C12.4971 21.7515 11.5029 21.7515 10.6584 21.3292L4.65836 18.3292C3.64201 17.821 3 16.7822 3 15.6459V8.3541Z"
      stroke="#262626"
      stroke-width="2"
    />
    <path d="M16.7363 9.5L12.6227 11.875" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path d="M12 13L12 17" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path d="M7.12305 9.5L11.2367 11.875" stroke="#262626" stroke-width="2" stroke-linecap="round" />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2111 1.77639C11.3373 1.21333 12.6627 1.21333 13.7889 1.77639L19.7889 4.77639C21.144 5.45396 22 6.83901 22 8.3541V15.6459C22 17.161 21.144 18.546 19.7889 19.2236L13.7889 22.2236C12.6627 22.7867 11.3373 22.7867 10.2111 22.2236L4.21114 19.2236C2.85601 18.546 2 17.161 2 15.6459V8.3541C2 6.83901 2.85601 5.45396 4.21115 4.77639L10.2111 1.77639Z"
      fill="url(#paint0_linear_18903_5647)"
    />
    <path d="M16.7363 9.5L12.6227 11.875" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M12 13L12 17" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M7.12305 9.5L11.2367 11.875" stroke="white" stroke-width="2" stroke-linecap="round" />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5647"
        x1="5.15789"
        y1="3.03234"
        x2="22.5011"
        y2="19.8757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconTools() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
